/* Custom JavaScript for DE MOI theme */

(function () {
  const BASE_EXCHANGE_RATES = {
    CHF: 1.0,
    USD: 1.15,
    EUR: 1.05,
    GBP: 0.90,
    SAR: 4.25,
    AED: 4.15,
    KWD: 0.35,
    QAR: 4.12,
    BHD: 0.43,
    OMR: 0.44,
    CAD: 1.55,
    AUD: 1.75,
    JPY: 170.0,
    INR: 95.0,
    SGD: 1.55,
    NZD: 1.90,
    HKD: 9.00,
    SEK: 12.0,
    NOK: 12.0,
    DKK: 7.80,
    PLN: 4.50,
    CZK: 26.0,
    HUF: 420.0,
    ILS: 4.20,
    TRY: 38.0,
    ZAR: 20.0,
    BRL: 6.00,
    MXN: 22.0,
    CNY: 8.30,
    KRW: 1550.0,
  };

  const CURRENCY_SYMBOLS = {
    USD: '$',
    EUR: '€',
    GBP: '£',
    CHF: 'CHF',
    SAR: 'SAR',
    AED: 'AED',
    KWD: 'KWD',
    QAR: 'QAR',
    BHD: 'BHD',
    OMR: 'OMR',
    CAD: 'CA$',
    AUD: 'AU$',
    JPY: '¥',
    INR: '₹',
    SGD: 'SG$',
    NZD: 'NZ$',
    HKD: 'HK$',
    SEK: 'kr',
    NOK: 'kr',
    DKK: 'kr',
    PLN: 'zł',
    CZK: 'Kč',
    HUF: 'Ft',
    ILS: '₪',
    TRY: '₺',
    ZAR: 'R',
    BRL: 'R$',
    MXN: 'MX$',
    CNY: '¥',
    KRW: '₩',
  };

  const SWISS_AND_EU_COUNTRIES = [
    'CH', 'LI',
    'AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE',
    'GB', 'NO', 'IS', 'MC', 'AD', 'SM', 'VA'
  ];
  const SWISS_AND_EU_CURRENCIES = ['CHF', 'EUR', 'GBP', 'DKK', 'SEK', 'NOK', 'PLN', 'CZK', 'HUF', 'RON', 'BGN', 'ISK'];
  const KNOWN_CURRENCIES = Object.keys(BASE_EXCHANGE_RATES);

  const COUNTRY_MAP = {
    CH: { name: 'Switzerland', currency: 'CHF', symbol: 'SFr' },
    DE: { name: 'Germany', currency: 'EUR', symbol: '€' },
    FR: { name: 'France', currency: 'EUR', symbol: '€' },
    IT: { name: 'Italy', currency: 'EUR', symbol: '€' },
    AT: { name: 'Austria', currency: 'EUR', symbol: '€' },
    GB: { name: 'United Kingdom', currency: 'GBP', symbol: '£' },
    US: { name: 'United States', currency: 'USD', symbol: '$' },
    AE: { name: 'United Arab Emirates', currency: 'AED', symbol: 'AED' },
    SA: { name: 'Saudi Arabia', currency: 'SAR', symbol: 'SAR' },
    QA: { name: 'Qatar', currency: 'QAR', symbol: 'QAR' },
    KW: { name: 'Kuwait', currency: 'KWD', symbol: 'KWD' },
    BH: { name: 'Bahrain', currency: 'BHD', symbol: 'BD' },
    OM: { name: 'Oman', currency: 'OMR', symbol: 'OMR' },
    NL: { name: 'Netherlands', currency: 'EUR', symbol: '€' },
    ES: { name: 'Spain', currency: 'EUR', symbol: '€' },
    SE: { name: 'Sweden', currency: 'SEK', symbol: 'kr' },
    NO: { name: 'Norway', currency: 'NOK', symbol: 'kr' },
    DK: { name: 'Denmark', currency: 'DKK', symbol: 'kr' },
    PL: { name: 'Poland', currency: 'PLN', symbol: 'zł' },
    CA: { name: 'Canada', currency: 'CAD', symbol: 'CA$' },
    AU: { name: 'Australia', currency: 'AUD', symbol: 'AU$' },
  };

  window.COUNTRY_MAP = COUNTRY_MAP;

  /**
   * Primary Global Country Detector
   */
  window.getActiveWebsiteCountry = function (fallback) {
    try {
      const savedCountry = localStorage.getItem('selected_shipping_country');
      if (savedCountry) return savedCountry.toUpperCase();
    } catch (e) {}

    try {
      const countryInput = document.querySelector('input[name="country_code"], [data-popout-input][name="country_code"]');
      if (countryInput && countryInput.value) {
        return countryInput.value.trim().toUpperCase();
      }
    } catch (e) {}

    try {
      if (window.Shopify && window.Shopify.country) {
        return String(window.Shopify.country).trim().toUpperCase();
      }
    } catch (e) {}

    return (fallback || 'CH').toUpperCase();
  };

  /**
   * Primary Global Currency Detector: Reads user selection or Shopify active current currency
   */
  window.getActiveWebsiteCurrency = function (fallback) {
    // 0. User manually selected shipping currency
    try {
      const savedCur = localStorage.getItem('selected_shipping_currency');
      if (savedCur && KNOWN_CURRENCIES.includes(savedCur.toUpperCase())) {
        return savedCur.toUpperCase();
      }
    } catch (e) {}

    // 1. Shopify native active currency
    try {
      if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
        return String(window.Shopify.currency.active).trim().toUpperCase();
      }
    } catch (e) {}

    // 2. Theme currency setting
    try {
      if (window.theme && window.theme.current_iso_code) {
        return String(window.theme.current_iso_code).trim().toUpperCase();
      }
      if (window.theme && window.theme.currency) {
        return String(window.theme.currency).trim().toUpperCase();
      }
    } catch (e) {}

    // 3. Country / Localization select input
    try {
      const countryInput = document.querySelector('input[name="country_code"], input[name="currency_code"], [data-popout-input]');
      if (countryInput && countryInput.value) {
        const val = countryInput.value.trim().toUpperCase();
        if (KNOWN_CURRENCIES.includes(val)) return val;
        if (COUNTRY_MAP[val]) return COUNTRY_MAP[val].currency;
      }
    } catch (e) {}

    // 4. Check visible prices currently rendered on the page/drawer
    try {
      const moneyElements = document.querySelectorAll(
        '[data-cart-price-holder] .money, [data-cart-total] .money, .cart__item .money, .price .money'
      );
      for (let i = 0; i < moneyElements.length; i++) {
        const txt = moneyElements[i].textContent.trim().toUpperCase();
        if (txt.includes('CHF') || txt.includes('SFR')) return 'CHF';
        if (txt.includes('QAR')) return 'QAR';
        if (txt.includes('SAR')) return 'SAR';
        if (txt.includes('AED')) return 'AED';
        if (txt.includes('KWD')) return 'KWD';
        if (txt.includes('BHD') || txt.includes('BD')) return 'BHD';
        if (txt.includes('OMR')) return 'OMR';
        if (txt.includes('$') || txt.includes('USD')) return 'USD';
        if (txt.includes('€') || txt.includes('EUR')) return 'EUR';
        if (txt.includes('£') || txt.includes('GBP')) return 'GBP';
      }
    } catch (e) {}

    return (fallback || 'CHF').toUpperCase();
  };

  /**
   * Helper to check whether active destination is International (outside Switzerland & Europe)
   */
  window.isInternationalWebsiteActive = function () {
    const cCode = window.getActiveWebsiteCountry();
    if (cCode) {
      return !SWISS_AND_EU_COUNTRIES.includes(cCode);
    }

    const cur = window.getActiveWebsiteCurrency();
    if (!SWISS_AND_EU_CURRENCIES.includes(cur)) {
      return true;
    }
    if (cur === 'CHF' || cur === 'EUR' || cur === 'GBP') return false;

    return false;
  };

  window.isGccWebsiteActive = window.isInternationalWebsiteActive;

  /**
   * Global helper: Get exchange rate against CHF (1.0)
   */
  window.getWebsiteExchangeRate = function (currency) {
    const cur = (currency || window.getActiveWebsiteCurrency()).toUpperCase();

    if (cur === 'CHF') {
      return 1.0;
    }

    try {
      if (
        window.Shopify &&
        window.Shopify.currency &&
        window.Shopify.currency.active === cur &&
        typeof window.Shopify.currency.rate === 'number'
      ) {
        return window.Shopify.currency.rate;
      }
    } catch (e) {}

    return BASE_EXCHANGE_RATES[cur] || 1.0;
  };

  /**
   * Format money value using active Shopify currency
   */
  window.formatWebsiteMoney = function (amount, currency) {
    const cur = (currency || window.getActiveWebsiteCurrency()).toUpperCase();
    const symbol = CURRENCY_SYMBOLS[cur] || cur;

    if (cur === 'USD') return `$ ${amount}`;
    if (cur === 'EUR') return `€ ${amount}`;
    if (cur === 'GBP') return `£ ${amount}`;
    if (cur === 'CHF') return `CHF ${amount}`;
    if (cur === 'BHD') return `${amount} BD`;
    if (cur === 'SAR' || cur === 'AED' || cur === 'KWD' || cur === 'QAR' || cur === 'OMR') {
      return `${cur} ${amount}`;
    }
    return `${symbol} ${amount}`;
  };

  /**
   * Synchronize Europe/Switzerland free shipping bars in cart drawer & announcement bar
   */
  function updateWorldwideFreeShippingBar() {
    const isIntl = window.isInternationalWebsiteActive();

    // Find all free shipping messages (in DOM and template)
    const queryWorldwide = '[data-cart-message][data-shipping-type="europe"], [data-cart-message][data-shipping-type="worldwide"], [data-cart-message][data-limit]';
    const msgEls = Array.from(document.querySelectorAll(queryWorldwide));

    const template = document.querySelector('template[data-cart-drawer-template]');
    if (template && template.content) {
      const templateWorldwide = template.content.querySelectorAll(queryWorldwide);
      templateWorldwide.forEach((el) => msgEls.push(el));
    }

    if (isIntl) {
      // Hide free shipping bars for international shoppers
      msgEls.forEach(function (msgEl) {
        msgEl.style.display = 'none';
        msgEl.classList.add('is-hidden');
      });
      return;
    }

    const cur = window.getActiveWebsiteCurrency();
    const rate = window.getWebsiteExchangeRate(cur);

    msgEls.forEach(function (msgEl) {
      msgEl.style.display = '';
      msgEl.classList.remove('is-hidden');

      const rawLimit = msgEl.getAttribute('data-limit');
      const baseLimitChf = rawLimit !== null && rawLimit !== '' ? parseFloat(rawLimit) : 200;

      const cartTotalElement = document.querySelector('[data-cart-total]');
      let cartTotalCents = 0;
      if (cartTotalElement && cartTotalElement.hasAttribute('data-cart-total')) {
        cartTotalCents = parseInt(cartTotalElement.getAttribute('data-cart-total'), 10) || 0;
      }

      const serverIso = (window.theme && window.theme.current_iso_code) || 'CHF';
      const serverRate = window.getWebsiteExchangeRate(serverIso);
      const cartTotalBaseChf = cartTotalCents / (serverRate || 1.0);
      const activeLimitCents = Math.round(baseLimitChf * rate * 100);
      const activeCartTotalCents = cartTotalBaseChf * rate;

      if (baseLimitChf <= 0) {
        // Switzerland: Free / complimentary shipping
        msgEl.classList.add('is-success');
        const defMsg = msgEl.querySelector('[data-message-default]');
        if (defMsg) defMsg.classList.add('is-hidden');
        msgEl.querySelectorAll('[data-cart-message-progress]').forEach((pb) => {
          pb.style.setProperty('--progress-width', '100%');
          pb.setAttribute('value', 100);
        });
        return;
      }

      const remainingCents = Math.max(0, activeLimitCents - activeCartTotalCents);
      const remainingAmount = Math.ceil(remainingCents / 100);

      const leftToSpendEl = msgEl.querySelector('[data-left-to-spend]');
      if (leftToSpendEl) {
        const formatted = window.formatWebsiteMoney(remainingAmount, cur);
        leftToSpendEl.innerHTML = `<strong class="cart-message__highlight">${formatted}</strong>`;
      }

      // Progress bar
      const percent = Math.min(100, Math.max(0, (activeCartTotalCents / activeLimitCents) * 100));
      msgEl.querySelectorAll('[data-cart-message-progress]').forEach((pb) => {
        pb.style.setProperty('--progress-width', `${percent}%`);
        pb.setAttribute('value', percent);
      });

      if (remainingCents <= 0) {
        msgEl.classList.add('is-success');
        const defMsg = msgEl.querySelector('[data-message-default]');
        if (defMsg) defMsg.classList.add('is-hidden');
      } else {
        msgEl.classList.remove('is-success');
        const defMsg = msgEl.querySelector('[data-message-default]');
        if (defMsg) defMsg.classList.remove('is-hidden');
      }
    });
  }

  window.updateWorldwideFreeShippingBar = updateWorldwideFreeShippingBar;

  function refreshCartUI() {
    updateWorldwideFreeShippingBar();
  }

  window.refreshCurrencyConverters = refreshCartUI;

  let debounceTimer = null;
  function triggerCartRefresh() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      refreshCartUI();
    }, 25);
  }

  function initCartDrawerCurrencyObserver() {
    const cartDrawer = document.querySelector('[data-cart-drawer], #cart-drawer');
    if (cartDrawer) {
      const observer = new MutationObserver(function (mutations) {
        let shouldRefresh = false;
        for (let i = 0; i < mutations.length; i++) {
          const mutation = mutations[i];
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            if (cartDrawer.classList.contains('is-open')) {
              shouldRefresh = true;
              break;
            }
          } else if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
            shouldRefresh = true;
            break;
          }
        }

        if (shouldRefresh) {
          triggerCartRefresh();
        }
      });

      observer.observe(cartDrawer, {
        attributes: true,
        attributeFilter: ['class', 'style'],
        childList: true,
        subtree: true,
      });
    }

    // Observe cart line items holder for dynamic AJAX quantity updates
    const itemsHolder = document.querySelector('[data-items-holder], #cartItemsHolder');
    if (itemsHolder) {
      const itemsObserver = new MutationObserver(function () {
        triggerCartRefresh();
        setTimeout(triggerCartRefresh, 80);
        setTimeout(triggerCartRefresh, 200);
      });
      itemsObserver.observe(itemsHolder, { childList: true, subtree: true });
    }

    // Cart drawer toggle clicks
    document.addEventListener('click', function (e) {
      const toggle = e.target.closest('[data-cart-drawer-toggle], .cart__toggle, [data-drawer-toggle]');
      if (toggle) {
        closeAllShippingPopouts();
        setTimeout(triggerCartRefresh, 30);
        setTimeout(triggerCartRefresh, 150);
        setTimeout(triggerCartRefresh, 350);
      }

      // Quantity buttons click in cart drawer
      const qtyBtn = e.target.closest('[data-quantity-plus], [data-quantity-minus], [data-item-remove], .cart__item__remove');
      if (qtyBtn) {
        setTimeout(triggerCartRefresh, 60);
        setTimeout(triggerCartRefresh, 180);
        setTimeout(triggerCartRefresh, 400);
      }
    });

    // Quantity inputs change
    document.addEventListener('change', function (e) {
      if (e.target.closest('[data-quantity-field], .cart__item__quantity-field, [data-quantity-select]')) {
        setTimeout(triggerCartRefresh, 60);
        setTimeout(triggerCartRefresh, 200);
        setTimeout(triggerCartRefresh, 450);
      }
    });

    // Theme cart custom events
    [
      'theme:cart:added',
      'theme:cart:loaded',
      'theme:cart:update',
      'theme:cart:close',
      'theme:cart:open',
      'cart:updated',
      'cart:refresh',
    ].forEach((evtName) => {
      document.addEventListener(evtName, function () {
        if (evtName === 'theme:cart:open' || evtName === 'theme:cart:added') {
          closeAllShippingPopouts();
        }
        triggerCartRefresh();
        setTimeout(triggerCartRefresh, 80);
      });
    });

    // Intercept cart fetch responses to re-apply shipping progress updates
    const originalFetch = window.fetch;
    if (typeof originalFetch === 'function') {
      window.fetch = function () {
        const promise = originalFetch.apply(this, arguments);
        const url = arguments[0];
        if (
          typeof url === 'string' &&
          (url.includes('/cart') || url.includes('api-cart-items') || url.includes('/change') || url.includes('/add'))
        ) {
          promise
            .then(function () {
              setTimeout(triggerCartRefresh, 40);
              setTimeout(triggerCartRefresh, 120);
              setTimeout(triggerCartRefresh, 300);
            })
            .catch(function () {});
        }
        return promise;
      };
    }
  }

  // =============================================================
  // SHIPPING LOCATION POPOUT CONTROLLER & SEARCH
  // =============================================================

  function closeAllShippingPopouts() {
    document
      .querySelectorAll('.select-popout--shipping-location, .announcement__cross-border .select-popout, .select-popout--country')
      .forEach(function (popout) {
        popout.classList.remove('select-popout--open');
        const toggle = popout.querySelector('[data-popout-toggle]');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
        const list = popout.querySelector('[data-popout-list]');
        if (list) {
          list.classList.remove('is-visible');
          list.classList.remove('select-popout__list--visible');
        }
      });
  }

  function syncAllShippingPopoutsUI() {
    const savedCountry = window.getActiveWebsiteCountry();

    document
      .querySelectorAll('.select-popout--shipping-location, .announcement__cross-border .select-popout, .select-popout--country')
      .forEach(function (popout) {
        const currentItem = popout.querySelector(`.select-popout__item[data-country-code="${savedCountry.toLowerCase()}"]`);
        let countryName = '';
        let currencyCode = '';

        if (currentItem) {
          const nameEl = currentItem.querySelector('.select-popout__option-name');
          const currEl = currentItem.querySelector('.select-popout__option-currency');
          if (nameEl) countryName = nameEl.textContent.trim();
          if (currEl) currencyCode = currEl.textContent.trim().toUpperCase();
        }

        if (!countryName && window.COUNTRY_MAP && window.COUNTRY_MAP[savedCountry]) {
          countryName = window.COUNTRY_MAP[savedCountry].name;
        }
        if (!currencyCode) {
          currencyCode = window.getActiveWebsiteCurrency();
        }

        const desktopName = popout.querySelector('.select-popout__country-name--desktop');
        if (desktopName && countryName) desktopName.textContent = countryName;

        const mobileCode = popout.querySelector('.select-popout__country-name--mobile');
        if (mobileCode) mobileCode.textContent = savedCountry;

        const currCode = popout.querySelector('.select-popout__currency-code');
        if (currCode && currencyCode) currCode.textContent = `(${currencyCode})`;

        const items = popout.querySelectorAll('.select-popout__item');
        items.forEach(function (item) {
          const option = item.querySelector('[data-popout-option]');
          const val = option ? (option.getAttribute('data-value') || '').toUpperCase() : '';
          const isCurrent = val === savedCountry;
          item.classList.toggle('select-popout__item--current', isCurrent);
          if (option) {
            if (isCurrent) {
              option.setAttribute('aria-current', 'true');
            } else {
              option.removeAttribute('aria-current');
            }
          }
        });
      });
  }

  function initShippingLocationPopouts() {
    // Sync UI from saved preferences
    syncAllShippingPopoutsUI();

    // Click toggle handler
    document.addEventListener('click', function (e) {
      // Close button or backdrop click
      const closeBtn = e.target.closest('[data-popout-close]');
      if (closeBtn) {
        e.preventDefault();
        e.stopPropagation();
        closeAllShippingPopouts();
        return;
      }

      // Popout toggle button click
      const toggleBtn = e.target.closest(
        '.announcement__cross-border [data-popout-toggle], .select-popout--shipping-location [data-popout-toggle], .select-popout--country [data-popout-toggle]'
      );
      if (toggleBtn) {
        e.preventDefault();
        e.stopPropagation();
        const popout = toggleBtn.closest('.select-popout');
        if (popout) {
          const isExpanded =
            popout.classList.contains('select-popout--open') || toggleBtn.getAttribute('aria-expanded') === 'true';

          if (!isExpanded) {
            // Close other shipping popouts
            closeAllShippingPopouts();

            // Open this one
            toggleBtn.setAttribute('aria-expanded', 'true');
            popout.classList.add('select-popout--open');
            const list = popout.querySelector('[data-popout-list]');
            if (list) {
              list.classList.add('is-visible');
              list.classList.add('select-popout__list--visible');
            }

            // Reset search input
            const searchInput = popout.querySelector('[data-popout-search]');
            if (searchInput) {
              searchInput.value = '';
              const items = popout.querySelectorAll('li[data-country-name]');
              items.forEach(function (item) {
                item.classList.remove('is-hidden');
                item.style.removeProperty('display');
              });
              const noResults = popout.querySelector('[data-popout-no-results]');
              if (noResults) {
                noResults.classList.remove('is-visible');
                noResults.style.display = 'none';
              }

              // Autofocus search on desktop
              if (window.innerWidth > 767) {
                setTimeout(function () {
                  searchInput.focus();
                }, 100);
              }
            }

            // Scroll current country into view
            const currentItem = popout.querySelector('.select-popout__item--current');
            const scrollContainer = popout.querySelector('[data-popout-scroll]');
            if (currentItem && scrollContainer) {
              setTimeout(function () {
                const itemTop = currentItem.offsetTop;
                scrollContainer.scrollTop = Math.max(0, itemTop - 60);
              }, 50);
            }
          } else {
            closeAllShippingPopouts();
          }
        }
        return;
      }

      // Keep open when clicking inside popout list (search, scrolling)
      if (
        e.target.closest(
          '.announcement__cross-border [data-popout-list], .select-popout--shipping-location [data-popout-list], .select-popout--country [data-popout-list]'
        )
      ) {
        const opt = e.target.closest('[data-popout-option]');
        if (!opt) return;
      }

      // Option item click
      const option = e.target.closest(
        '.announcement__cross-border [data-popout-option], .select-popout--shipping-location [data-popout-option], .select-popout--country [data-popout-option]'
      );
      if (option) {
        e.preventDefault();
        const popout = option.closest('.select-popout');
        const countryCode = (option.getAttribute('data-value') || '').toUpperCase();
        const currencyCode = (
          option.getAttribute('data-currency') ||
          (option.closest('.select-popout__item') && option.closest('.select-popout__item').getAttribute('data-currency-code')) ||
          'CHF'
        ).toUpperCase();
        const countryName = option.querySelector('.select-popout__option-name')
          ? option.querySelector('.select-popout__option-name').textContent.trim()
          : countryCode;

        if (popout && countryCode) {
          try {
            localStorage.setItem('selected_shipping_country', countryCode);
            localStorage.setItem('selected_shipping_currency', currencyCode);
            localStorage.setItem('selected_shipping_name', countryName);
            document.cookie = `localization_country_code=${countryCode}; path=/; max-age=31536000`;
            document.cookie = `selected_shipping_currency=${currencyCode}; path=/; max-age=31536000`;
          } catch (e) {}

          syncAllShippingPopoutsUI();
          closeAllShippingPopouts();

          window.dispatchEvent(
            new CustomEvent('currency:change', { detail: { currency: currencyCode, country: countryCode } })
          );
          window.dispatchEvent(new Event('storage'));

          const form = popout.closest('form');
          const input = popout.querySelector('[data-popout-input]');
          if (input) input.value = countryCode;
          if (form) {
            form.submit();
          }
        }
        return;
      }

      // Click outside to close
      if (
        !e.target.closest(
          '.select-popout--shipping-location, .announcement__cross-border .select-popout, .select-popout--country'
        )
      ) {
        closeAllShippingPopouts();
      }
    });

    // Escape key closes popouts
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.keyCode === 27) {
        closeAllShippingPopouts();
      }
    });

    // Instant search filter function for Shipping Location dropdown
    function filterPopoutSearch(inputEl) {
      if (!inputEl) return;
      const rawVal = inputEl.value || '';
      const query = rawVal.trim().toLowerCase();
      const popout = inputEl.closest('.select-popout');
      if (!popout) return;

      const items = popout.querySelectorAll('li[data-country-name]');
      let visibleCount = 0;

      items.forEach(function (item) {
        const name = (item.getAttribute('data-country-name') || '').toLowerCase();
        const code = (item.getAttribute('data-country-code') || '').toLowerCase();
        const currency = (item.getAttribute('data-currency-code') || '').toLowerCase();
        const text = (item.textContent || '').toLowerCase();

        const matches =
          !query || name.includes(query) || code.includes(query) || currency.includes(query) || text.includes(query);

        if (matches) {
          item.classList.remove('is-hidden');
          item.style.setProperty('display', 'block', 'important');
          visibleCount++;
        } else {
          item.classList.add('is-hidden');
          item.style.setProperty('display', 'none', 'important');
        }
      });

      const noResults = popout.querySelector('[data-popout-no-results]');
      if (noResults) {
        if (visibleCount === 0 && query) {
          noResults.classList.add('is-visible');
          noResults.style.setProperty('display', 'block', 'important');
        } else {
          noResults.classList.remove('is-visible');
          noResults.style.setProperty('display', 'none', 'important');
        }
      }
    }

    // Attach search filter listeners (input, keyup, search, paste)
    ['input', 'keyup', 'search', 'paste'].forEach(function (eventName) {
      document.addEventListener(eventName, function (e) {
        if (e.target && e.target.matches('[data-popout-search]')) {
          setTimeout(function () {
            filterPopoutSearch(e.target);
          }, 0);
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initCartDrawerCurrencyObserver();
      updateWorldwideFreeShippingBar();
      initShippingLocationPopouts();
    });
  } else {
    initCartDrawerCurrencyObserver();
    updateWorldwideFreeShippingBar();
    initShippingLocationPopouts();
  }
})();

